import { render, staticRenderFns } from "./TasksByCategoryDashboard.vue?vue&type=template&id=cef09cd4&"
import script from "./TasksByCategoryDashboard.vue?vue&type=script&lang=js&"
export * from "./TasksByCategoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TasksByCategoryDashboard.vue?vue&type=style&index=0&id=cef09cd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports